import { render, staticRenderFns } from "./LandingPageDestinationAmerica.vue?vue&type=template&id=1024842e&scoped=true&"
import script from "./LandingPageDestinationAmerica.vue?vue&type=script&lang=js&"
export * from "./LandingPageDestinationAmerica.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageDestinationAmerica.vue?vue&type=style&index=0&id=1024842e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024842e",
  null
  
)

export default component.exports